/**
 * Core – Document/Invoice template labels and placeholders
 */

export default {
  documentTemplate: {
    reasonForExemption: "Reason for exemption",
    to: "To",
    replyTo: "Reply to",
    subject: "Subject",
    body: "Body",
    enterEmail: "Enter email address",
    enterSubject: "Enter subject",
    enterEmailBody: "Enter email body",
    invoicePreview: "Invoice preview",
    currency: "Currency",
    currencyDetails: "Currency details",
    selectOrAddTax: "Select or add tax",
    taxName: "Tax name",
    rate: "Rate",
    discountDescription: "Discount Description",
    enterDiscountDescription: "Enter discount description",
    discount: "Discount",
    enterDiscountAmount: "Enter discount amount",
    type: "Type",
    salesCertificateNumber: "Sales Certificate Number",
    enterSalesCertificateNumber: "Enter your sales certificate number",
    invoiceNumber: "Invoice Number",
    enterInvoiceNumber: "Enter your invoice number",
    orderReference: "Order Reference",
    enterOrderReference: "Enter order reference",
    businessType: "Business Type",
    addNewTaxId: "Add New Tax ID",
    country: "Country",
    enterCountry: "Enter your Country",
    taxId: "Tax ID",
    enterTaxId: "Enter Tax ID",
    enterTaxName: "Enter tax name",
    enterRate: "Enter rate",
    selectOrAddCustomer: "Select or add customer",
    addNewCustomer: "Add new customer",
    fromIntegration: "(from integration)",
    itemDescription: "Item description",
    unitPrice: "Unit price",
    quantity: "Quantity",
    sellerVatNumber: "Seller VAT number",
    sellerTaxIdInCustomerCountry: "Seller tax ID in customer's country",
    salesTaxNumber: "Sales Tax Number",
    registrationCode: "Registration code",
    address: "Address",
    email: "Email",
    businessTypeTitle: "Business Type",
    reasonForExemptionTitle: "Reason For Exemption",
    invoiceDetails: "Invoice Details",
    invoiceSender: "Invoice Sender",
    invoiceRecipient: "Invoice Recipient",
    items: "Items",
    totals: "Totals",
    selectOrAddBankingInfo: "Select or add banking info",
    vatInvoiceTemplate: "VAT Invoice Template",
    addTaxId: "Add Tax ID",
  },
};
